import { apiRequest, authRequest } from '../config/api';

// Service API endpoints
export const serviceAPI = {
  // Admin endpoints (token required)
  addService: (serviceData) => authRequest('/Service/add', {
    method: 'POST',
    body: JSON.stringify(serviceData),
  }),
  
  updateService: (serviceId, serviceData) => authRequest(`/Service/update/${serviceId}`, {
    method: 'PUT',
    body: JSON.stringify(serviceData),
  }),
  
  deleteService: (serviceId) => authRequest(`/Service/delete/${serviceId}`, {
    method: 'DELETE',
  }),
  
  toggleFeatured: (serviceId) => authRequest(`/Service/toggle_featured/${serviceId}`, {
    method: 'POST',
  }),
  
  // Public endpoints (no token required)
  getAllServices: () => apiRequest('/Service/get_services', {
    method: 'GET',
  }),
  
  getActiveServices: () => apiRequest('/Service/get_services_active', {
    method: 'GET',
  }),
  
  getFeaturedServices: () => apiRequest('/Service/services/featured', {
    method: 'GET',
  }),

  getRandomFiveServices: (options = {}) => {
    const params = new URLSearchParams()
    if (options.active) params.append('active', '1')
    if (options.featured) params.append('featured', '1')
    
    const queryString = params.toString()
    const url = `/Service/services/random5${queryString ? `?${queryString}` : ''}`
    
    return apiRequest(url, {
      method: 'GET',
    })
  },

  getAllTags: (options = {}) => {
    const params = new URLSearchParams()
    if (options.active) params.append('active', '1')
    if (options.with_counts) params.append('with_counts', '1')
    
    const queryString = params.toString()
    const url = `/Service/services/tags${queryString ? `?${queryString}` : ''}`
    
    return apiRequest(url, {
      method: 'GET',
    })
  },
}; 